import { render, staticRenderFns } from "./PlayerMapHeader.vue?vue&type=template&id=4cca7488&"
import script from "./PlayerMapHeader.vue?vue&type=script&lang=js&"
export * from "./PlayerMapHeader.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMapHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports